module.exports = __webpack_public_path__ + "img/loginimagen.ca649fb6.png";